import styled from 'styled-components'
import { Popover } from '@material-ui/core'
import { customTheme } from '../../styles/customTheme'

export const popoverFiltroParceiroStyles = {
  Popover: styled(Popover)`
    .MuiPaper-rounded {
      border-radius: 10px;
    }
  `,
  ContainerPopoverParceiro: styled.div`
    padding: 12px;
    max-height: 200px;
    min-width: 300px;

    div {
      color: ${customTheme.colors.cinza06};
      display: flex;
      align-items: center;
      gap: 8px;
      border-bottom: 1px solid ${customTheme.colors.cinza03};
    }

    div:first-child {
      border-bottom: none;
    }

    div:last-child {
      border-bottom: none;
    }
  `
}
